import ConfigsSearcher from "../config/Configs";
export const currencyFormat = () => {
  const config = ConfigsSearcher();
  const locale = config.configFinder("LOCALE");
  const currency = config.configFinder("CURRENCY");
  const formatCurrency = (value) => {
    const quantity =
      value?.toLocaleString(locale, {
        style: "currency",
        currency: currency,
      }) || "-";

    let partes = quantity.toString().split(".");
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    let res = partes.join(".");
    return res;
  };
  return { formatCurrency };
};
